import React from "react";
import { Link } from "react-router-dom";

import { priceTwo } from '../data/data'

import { MdOutlineCheckCircle } from '../assets/icons/icons'

export default function PricingOne(){
    return(
        <>
        <div className="row justify-content-center">
            <div className="col-12">
                <div className="section-title text-center mb-4 pb-2">
                    <h6 className="text-primary">Our Pricing</h6>
                        <h4 className="title mb-4">Comfortable Plans & Rates</h4>
                    <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                </div>
            </div>
        </div>

        <div className="row">
            {priceTwo.map(( item, index) =>{
                return(
                    <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                        <div className="card pricing border-0 p-4 rounded-md shadow">
                            <div className="card-body p-0 py-3">
                                <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">{item.title}</span>
                                <h2 className="fw-bold mb-0 mt-3">{item.amount}</h2>
                                <p className="text-muted">{item.time}</p>

                                <ul className="list-unstyled">
                                    {item.features.map(( el, index ) =>{
                                        return(
                                            <li className="h6 text-muted mb-0 ms-0" key={index}><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>{el}</li>
                                        )
                                    })}
                                </ul>

                                <div className="mt-4">
                                    <div className="d-grid">
                                        <Link to="#" className="btn btn-primary">Buy Now</Link>
                                    </div>
                                    <p className="text-muted mt-3 mb-0">*No credit card required</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
        </>
    )
}